import React from "react";

import styles from "./CoinPill.module.css";
import coinLogo from "../../asset/icons/fleek-coin-logo.png";
import { useCoinBalance } from "../TopBar/TopBar";
import { hasSession } from "../AuthModal/AuthGate";

/**
 * The landing header's coin pill, from design/Marketplace Landing.dc.html:
 * 34px tall, sunken surface, subtle border, amber count. Shows "—" until the
 * wallet answers or while signed out.
 *
 * comingSoon: stores outside India, where coins don't run yet. The pill stays,
 * reading "Soon", and never asks for a balance.
 */
export const CoinPill = ({ comingSoon = false }) =>
  comingSoon ? (
    <div className={styles.pill} aria-label="Fleek coins: coming soon" title="Fleek coins are coming soon to your store">
      <img src={coinLogo} alt="" className={styles.icon} />
      <span className={styles.value}>Soon</span>
    </div>
  ) : (
    <CoinBalancePill />
  );

const CoinBalancePill = () => {
  const balance = useCoinBalance();
  const value = !hasSession() || balance === null ? "—" : Number(balance).toLocaleString("en-IN");
  return (
    <div className={styles.pill} aria-label="Fleek coin balance">
      <img src={coinLogo} alt="" className={styles.icon} />
      <span className={styles.value}>{value}</span>
    </div>
  );
};

export default CoinPill;
